module.exports = __webpack_public_path__ + "0ebbe3a6558ca85fe541f64fed9e84a3.svg";